// extracted by mini-css-extract-plugin
module.exports = {"raceLink":"_6b561cc","race":"_47a44fd","chevron":"_e300a5d","time":"_ac0bae1"};